/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_R_AicostInputs */

const en_mk_cmp_r_aicost = /** @type {(inputs: Mk_Cmp_R_AicostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI cost inside the plan`)
};

const id_mk_cmp_r_aicost = /** @type {(inputs: Mk_Cmp_R_AicostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biaya AI di dalam paket`)
};

/**
* | output |
* | --- |
* | "AI cost inside the plan" |
*
* @param {Mk_Cmp_R_AicostInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_r_aicost = /** @type {((inputs?: Mk_Cmp_R_AicostInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_R_AicostInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_r_aicost(inputs)
	return en_mk_cmp_r_aicost(inputs)
});